import type { SVGProps } from 'react';

import { strokeStyle } from '../Illustration.css';
import { useIllustrationShades } from '../Illustration.hooks';

type Props = SVGProps<SVGSVGElement> & {
  strokeWidth: number;
};

export const Announcements = ({ strokeWidth, ...delegated }: Props) => {
  const shades = useIllustrationShades();

  return (
    <svg fill="none" height="98" viewBox="0 0 97 98" width="97" xmlns="http://www.w3.org/2000/svg" {...delegated}>
      <path
        className={strokeStyle}
        d="M91.92 31.8055C92.554 30.4873 93.0483 29.1584 93.385 27.8295C92.8907 29.1799 92.4 30.5052 91.92 31.8055Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M93.4996 19.9919C90.0895 5.83588 67.1648 -0.783651 42.2914 5.20903C17.418 11.1981 0.0166471 27.5285 3.42671 41.6845C4.26131 45.1483 6.26365 48.1608 9.1794 50.6467C9.1794 50.6467 9.18656 50.6502 9.19014 50.6574C9.65222 51.0156 10.1107 51.3774 10.5692 51.7463C11.5578 52.4699 12.6253 53.1362 13.7715 53.7523C20.8066 57.5277 30.7036 59.2757 41.6968 58.4984C45.8841 58.2011 50.2291 57.5348 54.6349 56.4746C58.8903 55.4501 62.9237 54.1248 66.674 52.5559C77.0081 48.2396 85.175 42.1 89.7779 35.4518C90.6089 34.2554 91.3217 33.0411 91.9128 31.8197C91.9128 31.8197 91.9128 31.8161 91.9128 31.8125C92.3928 30.5123 92.8799 29.1869 93.3778 27.8365C94.0476 25.2002 94.1121 22.5638 93.496 19.9991L93.4996 19.9919ZM84.6342 28.7177C82.2557 34.148 76.5782 39.478 68.8053 43.6259C64.181 46.0939 58.8187 48.1464 52.9693 49.5577C47.4494 50.8867 42.0514 51.5099 37.0581 51.4956C27.8631 51.4741 20.0293 49.2998 15.2867 45.4205C12.9691 43.5256 11.3895 41.2224 10.7483 38.5646C8.08689 27.5177 22.6764 14.5294 43.3337 9.55757C63.9911 4.58218 82.8933 9.50384 85.5512 20.5507C86.1923 23.2086 85.8305 25.981 84.6306 28.7213L84.6342 28.7177Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M10.5692 51.7464C10.0892 51.3954 9.62713 51.0336 9.19012 50.6575C9.6522 51.0157 10.1107 51.3774 10.5692 51.7464Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.6341 28.7177C82.2557 34.148 76.5782 39.4781 68.8053 43.626C64.1809 46.094 58.8187 48.1465 52.9693 49.5578C47.4494 50.8867 42.0514 51.51 37.0581 51.4957C36.3882 45.4063 36.245 38.579 36.3918 31.3433C37.0796 34.2018 42.7964 35.2764 49.158 33.7433C55.5197 32.2102 60.1225 28.6533 59.4348 25.7948C59.1482 24.6164 58.0056 23.7388 56.3113 23.223C53.9078 22.4958 50.401 22.4958 46.6686 23.3949C42.9361 24.294 39.809 25.888 38.0037 27.6324C26.9855 31.9165 18.6645 38.5288 15.2903 45.4206C12.9727 43.5257 11.3931 41.2225 10.7519 38.5646C8.09046 27.5178 22.6799 14.5294 43.3373 9.55764C63.9947 4.58224 82.8969 9.50391 85.5547 20.5508C86.1959 23.2086 85.8341 25.9811 84.6341 28.7213V28.7177Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M36.3918 31.3399C36.313 35.3302 36.3202 39.1952 36.4599 42.8883C32.8492 44.9586 29.7472 47.5198 27.4082 50.5788C22.4435 49.5973 18.2741 47.8386 15.2974 45.41C18.6717 38.5218 26.9926 31.9094 38.0001 27.6254C36.7285 28.8468 36.1124 30.1578 36.3918 31.3363V31.3399Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M68.8089 43.6261C64.1846 46.0941 58.8223 48.1466 52.9729 49.5579C47.4531 50.8868 42.055 51.5101 37.0617 51.4957C36.3918 45.4064 36.2486 38.5791 36.3954 31.3434C37.0832 34.2019 42.8 35.2765 49.1617 33.7434C55.5233 32.2103 60.1262 28.6534 59.4384 25.7949C62.6515 30.2724 66.5057 36.3726 68.8089 43.6297V43.6261Z"
        fill={shades.secondary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.6342 28.7214C83.2157 31.9774 80.6008 35.1976 77.0439 38.1564C73.4476 37.3253 69.7331 36.8239 66.0114 36.6448C63.9589 32.4108 61.5697 28.7357 59.4384 25.7841C59.159 24.6057 58.0128 23.7281 56.3185 23.2159C68.0818 22.0051 78.4982 24.1114 84.6342 28.7178V28.7214Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.6342 28.7178C78.4947 24.1149 68.0746 22.0159 56.3114 23.2194C53.9078 22.4923 50.4011 22.4923 46.6686 23.3913C42.9362 24.2904 39.8091 25.8844 38.0038 27.6289C26.9855 31.9129 18.6646 38.5253 15.2903 45.417C12.9728 43.5222 11.3931 41.2189 10.7519 38.5611C10.3221 36.7809 10.3436 34.9469 10.7663 33.1057C11.2033 31.2001 12.0701 29.2837 13.3166 27.4032C18.3279 19.8488 29.4679 12.8925 43.3409 9.5541C63.9983 4.5787 82.9005 9.50037 85.5584 20.5472C86.1995 23.2051 85.8378 25.9776 84.6378 28.7178H84.6342Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M49.1616 33.7397C42.8 35.2728 37.0832 34.1982 36.3954 31.3398C36.1088 30.1577 36.7321 28.8575 38.0037 27.6289C39.8126 25.8844 42.9361 24.2904 46.6686 23.3914C50.3974 22.4923 53.9078 22.4923 56.3113 23.2194C58.0056 23.7316 59.1483 24.6092 59.4348 25.7913C60.1226 28.6497 55.5233 32.2067 49.1581 33.7397H49.1616Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M84.6629 51.8002C83.71 54.5691 82.7787 57.3379 81.8868 60.1534C80.9841 62.9402 80.1137 65.7915 79.2791 68.7251C78.8636 70.1651 78.5233 71.4438 78.2368 72.7226C77.9681 73.9154 77.7281 75.0939 77.4917 76.3798C66.8711 84.5181 54.7424 86.8214 41.3135 84.0561C40.8192 83.3432 40.3249 82.6197 39.8055 81.8782C39.0748 80.8108 38.3082 79.7397 37.5202 78.7189C35.568 76.1721 33.4833 73.6647 31.2804 71.2038C29.8117 69.549 28.2894 67.9156 26.7241 66.3216C28.3897 66.8696 30.1807 67.3245 32.0684 67.6684C39.2861 68.9938 48.0154 68.7108 57.06 66.5401C65.8824 64.416 73.5981 60.8196 79.3902 56.4997C81.3997 55.0061 83.162 53.4407 84.6629 51.8038V51.8002Z"
        fill={shades.white}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M91.9164 31.8126C91.3074 33.4639 90.7128 35.0758 90.1254 36.6626C88.1839 41.9246 86.375 46.8713 84.67 51.8002C83.1656 53.4336 81.3961 55.0096 79.3937 56.4997C73.6052 60.816 65.886 64.416 57.0635 66.5401C48.019 68.7179 39.2933 68.9902 32.0684 67.672C30.1771 67.3281 28.3897 66.8732 26.724 66.318C22.637 62.1271 18.2956 58.1367 13.9005 54.4616C12.7937 53.5338 11.6832 52.6312 10.5728 51.7464C11.5614 52.47 12.6289 53.1362 13.7751 53.7524C20.8102 57.5278 30.7072 59.2758 41.7004 58.4985C45.8877 58.2012 50.2327 57.5349 54.6385 56.4747C58.894 55.4502 62.9273 54.1249 66.6776 52.556C77.0117 48.2397 85.1786 42.1001 89.7815 35.4519C90.6125 34.2555 91.3254 33.0412 91.9164 31.8198V31.8126Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M77.4917 76.3799C77.1729 78.0885 76.8541 80.0049 76.4637 82.3582C75.4428 88.4154 71.4023 94.2433 62.5906 95.6904C53.7896 97.1519 47.9689 91.9831 45.6119 89.6261C44.2866 88.3079 42.8466 86.2769 41.3135 84.0597C54.7424 86.8214 66.8675 84.5182 77.4917 76.3835V76.3799Z"
        fill={shades.primary.medium}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M37.0617 51.4993C35.4606 51.4993 33.9024 51.4276 32.4051 51.2808C30.6607 51.1303 28.9951 50.9046 27.4047 50.5823C29.7473 47.5232 32.8457 44.9621 36.4564 42.8917C36.5459 45.4242 36.6964 47.8564 36.9328 50.2026C36.9686 50.636 37.0152 51.0658 37.0617 51.4993Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        className={strokeStyle}
        d="M77.0404 38.1599C75.5288 39.4315 73.8309 40.6351 71.9898 41.8064H71.9647C70.9546 42.4332 69.9086 43.0493 68.8125 43.6332C68.7051 43.3001 68.6012 42.967 68.4794 42.6446C67.7594 40.5348 66.9284 38.536 66.0078 36.6483C69.7295 36.8238 73.444 37.3253 77.0404 38.1599Z"
        fill={shades.black}
        strokeWidth={strokeWidth}
      />
      <path
        d="M60.6621 70.9567C61.1708 72.9733 61.6722 74.9792 62.163 76.978C61.0382 77.3613 59.9099 77.7016 58.7816 78.0025C58.5273 76.9852 58.2694 75.9643 58.0079 74.9434C56.8724 75.2264 55.7369 75.4664 54.605 75.6634C54.8736 76.7058 55.1423 77.7445 55.4038 78.7797C54.279 78.9982 53.1614 79.1773 52.0438 79.3135C51.4994 77.2001 50.9442 75.0795 50.3854 72.9483C53.7739 72.6545 57.2198 71.9954 60.6585 70.9567H60.6621Z"
        fill={shades.black}
      />
    </svg>
  );
};
